import { render } from "./LicenseManagementTab.vue?vue&type=template&id=5f0cb9c7"
import script from "./LicenseManagementTab.vue?vue&type=script&lang=js"
export * from "./LicenseManagementTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__